// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__+i72r","shellSelectPagination":"Pagination_shellSelectPagination__-ScOy","shellPrevNextButton":"Pagination_shellPrevNextButton__FLLNI"};